import IconCalendar from 'src/icons/IconCalendar'

import TaskOffsetMenu from './TaskOffsetMenu'

interface DueDaysMenuProps {
  defaultDueInHours: number | undefined
  setDefaultDueInHours: (hours: number | undefined) => void
}

const DueDaysMenu = ({
  defaultDueInHours,
  setDefaultDueInHours,
}: DueDaysMenuProps) => (
  <TaskOffsetMenu
    value={defaultDueInHours}
    setValue={setDefaultDueInHours}
    label="Default due"
    testId="due-offset-menu-trigger"
    icon={
      <IconCalendar className="h-3 w-3 fill-none stroke-doubleNickel-gray-700" />
    }
  />
)

export default DueDaysMenu
